export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14838.fd4c07b4.jpg";